import { FetchArgs, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import moment from 'moment';
import apiConfig from 'src/api/APIConfig';
import { RootState } from 'src/store/index';

export const workareaBaseQuery = retry(
  async (args: string | FetchArgs, api, extraOptions) => {
    const result = await fetchBaseQuery({
      baseUrl: apiConfig.appConfig.apisysadmin,
      prepareHeaders: (headers, { getState }) => {
        const token = ((getState() as RootState)?.user?.user as any)?.sponsorToken;
        const sponsor = ((getState() as RootState)?.user?.user as any)?.sponsor_sponsor_name;
        if (token) {
          headers.set('authorization', `Bearer ${token}`);
        }
        if (sponsor) {
          headers.set('sponsor', sponsor);
        }
        headers.set('site_token', `${(getState() as RootState).user?.user?.siteToken}`);
        headers.set('user_date_time', moment().format());
        return headers;
      }
    })(args, api, extraOptions);

    if (
      result?.error &&
      !(
        result.error?.status === 500 ||
        result.error?.status === 502 ||
        result.error?.status === 503 ||
        result.error?.status === 504
      )
    ) {
      retry.fail(result.error);
    }
    return result;
  },
  {
    maxRetries: 0
  }
);
